import React from 'react';
import { Link } from 'react-router-dom';
import { CalendarIcon, UserIcon } from 'lucide-react';
import { BrandIcon } from '../components/BrandIcon';
export const SplashPage = () => {
  return <div className="w-full min-h-screen bg-gray-900 text-white" data-id="element-1119">
      <div className="max-w-4xl mx-auto min-h-screen flex flex-col" data-id="element-1120">
        {/* Logo section */}
        <div className="p-8 flex items-center justify-center" data-id="element-1121">
          <div className="mr-2" data-id="element-1122">
            <BrandIcon data-id="element-1123" />
          </div>
          <h1 className="text-4xl font-bold" data-id="element-1124">LaVee</h1>
        </div>
        {/* Main content */}
        <div className="flex-1 flex flex-col items-center justify-center px-4 text-center" data-id="element-1125">
          <h1 className="text-5xl font-bold mb-6" data-id="element-1126">Your life, your passions.</h1>
          <p className="text-xl mb-8 max-w-2xl" data-id="element-1127">
            LaVee helps you get access to games, events, news, and experiences
            tailored just for you.
          </p>
          {/* Hero image */}
          <div className="w-full relative mb-6" data-id="element-1128">
            <img src="https://images.unsplash.com/photo-1504450758481-7338eba7524a?q=80&w=2069&auto=format&fit=crop" alt="NBA basketball game" className="w-full h-64 object-cover rounded-xl" data-id="element-1129" />
            <div className="absolute inset-0 bg-gradient-to-t from-black to-transparent rounded-xl" data-id="element-1130"></div>
          </div>
          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 w-full max-w-lg" data-id="element-1131">
            <Link to="/onboard/setup" className="flex-1 bg-gradient-to-r from-sky-500 to-blue-600 hover:from-sky-600 hover:to-blue-700 text-white font-medium py-4 px-6 rounded-xl flex items-center justify-center transition-colors" data-id="element-1132">
              <UserIcon className="mr-2" size={20} data-id="element-1133" />
              Let's Personalize This!
            </Link>
            <button className="flex-1 border-2 border-sky-500 text-sky-400 hover:bg-gray-800 font-medium py-4 px-6 rounded-xl flex items-center justify-center transition-colors" onClick={() => alert('NBA 2025-26 schedule would be added to your calendar')} data-id="element-1134">
              <CalendarIcon className="mr-2" size={20} data-id="element-1135" />I just want the NBA
              game calendar.
            </button>
          </div>
        </div>
        {/* Footer */}
        <div className="p-6 text-center text-gray-500 text-sm" data-id="element-1136">
          © 2025 LaVee | Your Personal Assistant
        </div>
      </div>
    </div>;
};